import AuthLayout from "layouts/AuthLayout";
import Login from "pages/auth/Login";

const AUTH_ROUTES = [
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
    ],
  },
];

export default AUTH_ROUTES;
